import './App.css';
import {useEffect, useState} from 'react';
import {auth, storage, db} from './firebase.js';

function Messenger () {
    const [user, setUser] = useState();
    const [progress, setProgress] = useState(0);
    const [file, setFile] = useState(null);

    useEffect(() => {
        
    },[])

    return(
        
    <div className="messenger">
        <div className="sidebar">
        <h2>Olá mundo!</h2>
        </div>
        <div className="contentarea">

        </div>
    </div>


    );
    

}

export default Messenger;